import React, { FC } from 'react';

import App from '../../../models/app';
import { AppListItem } from './AppListItem';

interface AppListProps {
  apps: App[];
  collectionId?: string;
}

export const AppList: FC<AppListProps> = ({ apps, collectionId }) => (
  <div>
    {apps.map((app, index) => (
      <AppListItem key={index} app={app} collectionId={collectionId}/>
    ))}
  </div>
)
